export const frontmatter = {
    "draft": false,
    "title": "Guía: Canales",
    "description": "Cómo crear y configurar canales en OnnIA: datos generales, horario de atención, e integraciones de WhatsApp, WebChat y API.",
    "sidebar_label": "Canales",
    "sidebar_group": "referencia",
    "sidebar_order": 4
}

export const toc = [
    {
        "depth": 2,
        "id": "acceso-al-modulo",
        "value": "Acceso al módulo"
    },
    {
        "depth": 2,
        "id": "crear-un-canal",
        "value": "Crear un canal"
    },
    {
        "depth": 3,
        "id": "paso-1-datos-generales",
        "value": "Paso 1: Datos generales"
    },
    {
        "depth": 3,
        "id": "paso-2-horario-de-atencion",
        "value": "Paso 2: Horario de atención"
    },
    {
        "depth": 3,
        "id": "paso-3-integraciones",
        "value": "Paso 3: Integraciones"
    },
    {
        "depth": 2,
        "id": "acciones-sobre-canales-existentes",
        "value": "Acciones sobre canales existentes"
    },
    {
        "depth": 2,
        "id": "recomendaciones",
        "value": "Recomendaciones"
    }
]